module.exports = __webpack_public_path__ + "static/img/AIImg.41657ee.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/AIImg.webp
// module id = TuQt
// module chunks = 1